export default {

    conectado: false,
    mercadoAuth: null,
    mercadoPending: false,
    mercadoProductStatus: null,
    mercadoCategoryPrediction: null,
    mercadoCategories: [],
    mercadoCategoryAttributes: [],
    mercadoPublishing: false,
    mercadoPublishError: null,

    mercadoListingTypes: [],

    mercadoProductPrices: [],
    mercadoLoadingPrices: false,

    mercadoAvailableItems:        [],
    mercadoAvailableItemsPaging:  {},
    mercadoAvailableItemsLoading: false,
    mercadoLinkedItem:            null,
    mercadoLinkedItemLoading:     false,
    mercadoIncident:              null, 

    mlTransfers:        [],
    mlTransfersLoading: false,
    mlTransfersParams: {
        date_from:    '',
        date_to:      '',
        ml_order_id:  '',
        product_code: '',
        status:       '',
},

}


// WEBPACK FOOTER //
// ./src/modules/mercado-api/state.js